import {Injector, ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IMaskModule} from 'angular-imask';
import {Store, StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {NgxMaskDirective, NgxMaskPipe} from 'ngx-mask';

import { AppComponent } from './containers/app.component';
import { ProjectPickerComponent } from './components/project-picker.component';
import { ProjectComponent } from './containers/project.component';
import { ProjectBrowseComponent } from './containers/project-browse/project-browse.component';
import { SharedModule } from '../shared/shared.module';
import { UserMenuComponent } from './components/user-menu.component';
import { ProjectBrowseGridComponent } from './components/project-browse-grid/project-browse-grid.component';
import { ProjectSearchComponent } from './components/project-search.component';
import { MaterialModule } from '../material/material.module';
import {CreateProjectModalComponent} from './components/create-project-modal/create-project-modal.component';
import {AdvancedReportsComponent} from './components/advanced-reports/advanced-reports.component';
import {metaReducers, ProjectBrowseReducerProvider, ProjectBrowseReducerToken} from './reducers';
import {ProjectBrowseEffect} from './effects/project-browse.effect';
import {
  IStartcardImportService,
  StartcardImportToken,
  UkStartcardImportService,
  UsaStartcardImportService
} from '../shared/data-services/startcard-import.data.service';
import {ServiceRegion} from '../../../common/constants';
import {getState} from '../shared/utils';
import {selectRegion} from '../selectors/region.selector';

export const COMPONENTS = [
  AppComponent,
  ProjectComponent,
  ProjectPickerComponent,
  ProjectBrowseComponent,
  UserMenuComponent,
  ProjectBrowseGridComponent,
  ProjectSearchComponent,
  CreateProjectModalComponent,
  AdvancedReportsComponent
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        NgbModule,
        SharedModule,
        ScrollingModule,
        MaterialModule,
        ReactiveFormsModule,
        IMaskModule,
        StoreModule.forFeature('project', ProjectBrowseReducerToken, {metaReducers}),
        EffectsModule.forFeature([
          ProjectBrowseEffect
        ]),
        NgxMaskDirective,
        NgxMaskPipe
    ],
  providers: [
    {provide: Window, useValue: window},
    ProjectBrowseReducerProvider,
    {
      provide: StartcardImportToken,
      useFactory: (injector: Injector, store: Store): IStartcardImportService => {
        const region = getState<ServiceRegion>(store, selectRegion);
        return region === ServiceRegion.UK ? injector.get(UkStartcardImportService) : injector.get(UsaStartcardImportService);
      },
      deps: [Injector, Store]
    }
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
        ngModule: CoreModule,
        providers: [],
    };
}
}
